<dynamic-view-v2
    *ngIf="!isLoading"
    entityType="qa-user-groups"
    [viewName]="qaUserGroup"
    [record]="qaUserGroupRecord"
    [fields]="fields"
    [showLocalizedValuesButton]="true"
>
</dynamic-view-v2>